import { render, staticRenderFns } from "./my_homework.vue?vue&type=template&id=08eff3ca&scoped=true&"
import script from "./my_homework.vue?vue&type=script&lang=js&"
export * from "./my_homework.vue?vue&type=script&lang=js&"
import style0 from "./my_homework.vue?vue&type=style&index=0&id=08eff3ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08eff3ca",
  null
  
)

export default component.exports